import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Layout, PageHeader } from "../components/Layout";
import api from "../lib/api";

export default function BreedLibrary() {
  const [breeds, setBreeds] = useState([]);
  useEffect(() => { api.get("/breeds").then((r) => setBreeds(r.data)); }, []);
  const featured = breeds.find((b) => b.featured);
  const rest = breeds.filter((b) => !b.featured);
  return (
    <Layout>
      <PageHeader label="Breed Library" title="Know The Breed"
        subtitle="Structured guides on temperament, care, exercise and ownership fit — so you choose the right dog for your life." />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12">
        {featured && (
          <Link to={`/breeds/${featured.slug}`} className="relative block overflow-hidden border border-eon-border group mb-8 min-h-[360px]">
            <img src={featured.image} alt={featured.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-eon-bg via-eon-bg/50 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 lg:p-12">
              <div className="eon-label mb-3">Flagship Breed</div>
              <h2 className="eon-heading text-4xl lg:text-6xl uppercase">{featured.name}</h2>
              <p className="mt-4 text-eon-text/80 max-w-xl">{featured.temperament}</p>
              <span className="mt-6 flex items-center gap-2 text-eon-gold text-sm font-bold uppercase tracking-wider">Read guide <ArrowUpRight size={18} /></span>
            </div>
          </Link>
        )}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {rest.map((b, i) => (
            <Link key={b.slug} to={`/breeds/${b.slug}`} data-testid={`breed-card-${b.slug}`} className="eon-card group animate-fade-up" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={b.image} alt={b.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-eon-bg to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="font-display text-2xl font-bold">{b.name}</h3>
                <div className="eon-label mt-1">{b.group}</div>
                <p className="text-sm text-eon-text/70 mt-3 line-clamp-2">{b.temperament}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
